import React, { lazy } from 'react';
import { Phone } from 'lucide-react';
export function AccidentsHappen() {
  return <section className="bg-white border-b border-slate-200 overflow-hidden" data-id="element-455" data-mp="30tpl93ufb77f">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-456" data-mp="2mtevy58ri0od">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center py-12 lg:py-16" data-id="element-457" data-mp="2mswsoonomm6y">
          <div className="text-center lg:text-left order-2 lg:order-1 scroll-slide-left" data-id="element-458" data-mp="2rqy72wa5xxc3">
            <h2 className="text-3xl md:text-5xl font-bold text-navy-900 mb-4 leading-tight" data-id="element-459" data-mp="2d2todsb41ltb">
              Accidents Happen.
              <br data-id="element-460" data-mp="2hwenxoscqnum" />
              <span className="text-brand-blue" data-id="element-461" data-mp="242x5k7bejh66">We Fix Them.</span>
            </h2>
            <p className="text-lg text-slate-600 mb-6 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-462" data-mp="240u6yyw6ofpu">
              From rock chips on the highway to shattered windows in the
              driveway, Kosin's Glass repairs and replaces auto glass for cars,
              trucks and SUVs across Southeast Michigan.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-463" data-mp="awgvycwnigqe">
              <a href="#quote" className="inline-flex items-center justify-center bg-brand-blue hover:bg-brand-hover text-white font-bold py-3 px-6 rounded-lg transition-colors shadow-lg shadow-brand-blue/20" data-id="element-464" data-mp="5xmepfec108e">
                Get a Free Quote
              </a>
              <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-white border-2 border-slate-200 hover:border-brand-blue text-navy-900 font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-465" data-mp="3nduigz56u0vl">
                <Phone className="w-4 h-4" data-id="element-466" data-mp="10m9t7t7y3iv" />
                517-545-7772
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative scroll-fade-scale" data-id="element-467" data-mp="34ncu16re1rg1">
            <img src="https://cdn.magicpatterns.com/uploads/5GZJEbefwz2EYdYEfUvFir/autoglasspic1.webp" alt="Red Cadillac Escalade SUV. Kosin's Glass services foreign and domestic vehicles." className="block w-full h-auto object-contain" loading="lazy" data-id="element-468" data-mp="34ljjvhhkgp3a" />
          </div>
        </div>
      </div>
    </section>;
}